import React, { useState } from 'react';
import { adminbannerAPI } from '../../Handlers/adminbannerAPI';
import styles from '../../styles/components/forms/BannerForm.module.css'; 

function EditBannerForm({ banner, products, onSuccess }) {
    const [formData, setFormData] = useState({
        product_id: banner?.product_id || '',
        image: null // Apenas um campo
    });
    const [loading, setLoading] = useState(false);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

    const [preview, setPreview] = useState(
        banner?.image ? `${BASE_URL}/static/uploads/banners/${banner.image}` : null
    );

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({ ...prev, image: file }));
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        const data = new FormData();
        data.append('product_id', formData.product_id);
        if (formData.image) data.append('image', formData.image);

        try {
            await adminbannerAPI.update(banner.order, data); 
            onSuccess();
        } catch (error) {
            console.error("Erro ao salvar banner:", error);
            alert("Erro ao salvar banner.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className={styles.form}>
            <header className={styles.header}>
                <h2 className={styles.title}>Editar Banner Slot {banner.order}</h2>
            </header>

            <div className={styles.formGroup}>
                <label className={styles.label}>Produto Vinculado</label>
                <select 
                    className={styles.select}
                    value={formData.product_id}
                    onChange={(e) => setFormData({...formData, product_id: e.target.value})}
                >
                    <option value="">Banner Informativo (Sem link)</option>
                    {products.map(p => (
                        <option key={p.id} value={p.id}>{p.name}</option>
                    ))}
                </select>
            </div>

            <div className={styles.uploadCard}>
                <label className={styles.label}>Imagem do Banner (PC & Mobile)</label>
                <div className={styles.dropzone}>
                    {preview ? (
                        <img src={preview} className={styles.previewImg} alt="Banner Preview" />
                    ) : (
                        <div className={styles.placeholder}>Recomendado: 1920x600</div>
                    )}
                    <input 
                        type="file" 
                        accept="image/*"
                        onChange={handleFileChange}
                        className={styles.fileInput}
                        id="banner-input"
                    />
                    <label htmlFor="banner-input" className={styles.fileLabel}>Alterar Imagem</label>
                </div>
            </div>

            <button type="submit" className={styles.submitButton} disabled={loading}>
                {loading ? "Salvando..." : "Salvar Alterações"}
            </button>
        </form>
    );
}

export default EditBannerForm;